import React from "react";
import { Grid, Typography } from "@mui/material";
import IdeaModel from "./IdeaModel";
import "./IdeaBoard.css";

const IdeaBoard = () => {
  return (
    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
      <Grid className="idea-board-title">
        <Typography variant="h4" className="showcaseTitle">
          Try idea board with our styles
        </Typography>
      </Grid>
      <div className="modelCard">
        <IdeaModel />
      </div>
    </Grid>
  );
};

export default IdeaBoard;
